import enLang from './entries/en-US';
import jaLang from './entries/ja';
import esLang from './entries/es';
import ptLang from './entries/pt';
import cookie from 'util/CookieHelper';
import moment from 'moment';

const messages = {
    en: enLang,
    ja: jaLang,
    es: esLang,
    pt: ptLang
};

const AppLocale = {
    preferred: () => {
        var preferredLanguage = cookie.get('PreferredLanguage');
        var translation;

        if (preferredLanguage) {
            translation = messages[preferredLanguage.toLowerCase()];
        }
        else {
            var locale = navigator.language.substring(0, 2);
            translation = messages[locale];
            console.info(`No preferred language found, using browser locale: "${locale}"`);
        }

        if (!translation) {
            console.warn(`No translation found for language "${preferredLanguage}", falling back to en`);
        }

        // if language is not supported fall back to english
        return translation || messages['en'];
    },

    getTimeAgoString: (dateString) => {
        if (dateString) {
            var momentDate = moment(dateString);

            if (momentDate.isValid()) {
                var locale = moment.locale();
                var fromNow = momentDate.fromNow(false);

                if (locale === 'en') {
                    // "5 minutes ago (January 15 2023, 3:42 pm)"
                    return `${fromNow} (${momentDate.format('MMMM Do YYYY, h:mm a')})`;
                } else {
                    return `${fromNow} ${momentDate.format('LLL')}`;
                }
            }

            return '';
            
        }
    },

    getTimeAgoStringShort: (dateString) => {

        if (dateString) {
            var momentDate = moment(dateString);
            return momentDate.fromNow(false);
        }

        return '';
    }
};

export default AppLocale;
